import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { EkubService } from './ekub.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Main } from '@app/core/main.service';
import { environment } from '@env/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransactionService } from '../transaction/transaction.service';
import { AdminService } from '@app/admin/admin.service';

@Component({
    selector: 'cp-ekub-detail',
    templateUrl: './ekub.detail.component.html',
    styleUrls: ['./ekub.detail.component.scss']
})
export class EkubDetailComponent {
    ekub: any;
    id: string;
    ekub_date: any;
    filter: string;
    trxnFilter: string;
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    ekubMembers: any = [];
    ekubTransactions: any = [];
    branches: any = [];
    syncing = false;
    syncText = 'Sync';
    selectedMember: any = {};
    notification: any = {};
    membershipForm!: FormGroup;
    notificationForm!: FormGroup;
    baseUrl: string = environment.production
        ? environment.ONLINE_BASE_URL :
        environment.LOCAL_BASE_URL;
    statusFilter: string;
    constructor(private api: EkubService,
        @Inject(Restangular) public Restangular, private route: ActivatedRoute, private router: Router, private adminApi: AdminService, private formBuilder: FormBuilder, private mainService: Main, private trxnApi: TransactionService) {
        debugger;
        this.filter = '';
        this.statusFilter = '';
        this.itemsPerPage = 10;
        this.totalItems = 0;
        this.currentPage = 1;
        this.id = this.route.params['value']['id'];
        this.getEkub(this.id);
        this.getEkubMembers();
        this.getEkubTransactions();
        this.getBranches();
    }



    get title() { return this.notificationForm.get('title'); }
    get content() { return this.notificationForm.get('content'); }
    get type() { return this.notificationForm.get('type'); }

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.membershipForm = this.formBuilder.group({
            ekub: [, [Validators.required,]],
            username: [, [Validators.required]],
            member: [, [Validators.required]],
            branch: [],
            code: [, [Validators.required]],
            rating: [, [Validators.required]],
            status: [, [Validators.required]],
            remark: [],
        });

        this.notificationForm = this.formBuilder.group({
            title: ['', [Validators.required,]],
            content: ['', [Validators.required,]],
            type: ['info', [Validators.required,]], //don't add status it conflicts with the post request 
        });
    }

    getMembersFilter(filter: any) {
        this.filter = filter;
        this.getEkubMembers();
    }


    getTransactionsFilter(filter: any) {
        this.trxnFilter = filter;
        this.getEkubTransactions();
    }


    getEkub(ekubId: any) {
        this.api.getEkub(ekubId).subscribe((resp: any) => {
            this.ekub = resp.data;
        });
    }

    getEkubMembers() {
        this.api.getEkubMembersList(this.id, this.currentPage, this.filter).subscribe((resp: any) => {
            debugger;
            this.ekubMembers = resp.data;
            this.totalItems = resp.meta.pagination.total;
            this.itemsPerPage = resp.meta.pagination.per_page;
        }, (err: any) => {
            debugger;
            //this.mainService.addToast('Error', err.statusText);
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }

    getEkubTransactions() {
        debugger;
        this.api.getEkubTransactionsList(this.id, this.currentPage, this.trxnFilter).subscribe((resp: any) => {
            debugger;
            this.ekubTransactions = resp.data;
            this.totalItems = resp.meta.pagination.total;
            this.itemsPerPage = resp.meta.pagination.per_page;
        }, (err: any) => {
            debugger;
            //this.mainService.addToast('Error', err.statusText);
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }

    getBranches() {
        var filter = '?all=true';
        this.api.getBranches(filter).subscribe((resp: any) => {
            debugger;
            this.branches = resp.data;
            this.branches.forEach(element => {
                element.text = element.name + ' - ' + element.city;
            });
        }, (err: any) => {
            debugger;
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }

    pageChanged(event: any) {
        event = event;
        this.currentPage = this.currentPage;
        this.getEkubMembers();
    }

    broadcastNotification() {
        debugger;
        //this.isLoading = !this.isLoading;
        this.statusFilter;
        this.notification = this.notificationForm.value;
        this.adminApi.broadcastNotification(this.id, this.notification, this.statusFilter).subscribe((res: any) => {
            debugger;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Success', body: 'Notification  successfully added!', type: 'dark' });
            this.router.navigate(['/customers']);
        }, (err) => {
            err = err;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Success', body: 'Could not add notification!', type: 'danger' });
        });
    }

    setMember(member: any) {
        debugger;
        this.membershipForm.get('code').setValue(member.pivot.code);
        this.membershipForm.get('branch').setValue(member.pivot.branch_id);
        this.membershipForm.get('status').setValue(member.pivot.status);
        this.membershipForm.get('remark').setValue(member.pivot.remark);
        this.membershipForm.get('username').setValue(member.username + ' - ' + member.phone_number);
        this.selectedMember = this.membershipForm.value;
        this.selectedMember.member = member.id;
        this.selectedMember.ekub = member.pivot.ekub_id;
    }

    updateMembership(ekub: string = null, user: string = null, code: string = null, status: string = null, branch: string = null, remark: string = null) {
        debugger;
        var dto;
        if (this.membershipForm.value.code) {
            dto = this.membershipForm.value;
            dto.member = this.selectedMember.member;
            dto.ekub = this.selectedMember.ekub;
        } else {
            dto = {
                ekub: ekub,
                member: user,
                code: code,
                status: status,
                branch: branch,
                remark: remark
            };
        }

        this.api.updateMembership(dto).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: "Ekub Status sucessfully changed", type: 'success' });
            this.getEkubMembers();
        }, (err: any) => {
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }

    deactivateMember(id: string, status: string) {
        debugger;
        this.api.deactivateMember(id, status).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: "Member status sucessfully changed", status: 'success' });
            this.getEkubMembers();
        }, (err: any) => {
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }


    changeTrxnStatus(id: any, status: any) {
        this.trxnApi.changeTransactionStatus(id, status).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
            this.getTransactionsFilter('');
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

        });
    }

    sync() {
        this.syncing = true;
        this.syncText = "...";
        setTimeout(() => { this.syncRatings(this.id); }, 5000);
    }

    syncRatings(ekubId: string) {
        debugger;
        this.api.syncRatings(ekubId).subscribe((res: any) => {
            debugger;
            this.mainService.toast({ title: 'Success', body: res.data.data.detail, type: 'success' });
            this.getEkubMembers();
            this.syncText = "Sync";
            this.syncing = false;
        }, (err: any) => {
            debugger;
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
            this.syncing = false;
        });
    }

}
